"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIE = isIE;
exports.isEdge = isEdge;
exports.isIeOrEdge = isIeOrEdge;

function isIE() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  // MSIE used to detect old browsers and Trident used to newer ones
  return ua.indexOf('MSIE') > -1 || ua.indexOf('Trident/') > -1;
}

function isEdge() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return ua.indexOf('Edge/') > -1;
}

function isIeOrEdge() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIE(ua) || isEdge(ua);
}